import React from "react";
import { cn } from "../../lib/cn";

const TONES = {
  neutral: "bg-line/8 text-text ring-line/15",
  primary: "bg-primary/10 text-primary ring-primary/20",
  accent: "bg-accent/15 text-ink ring-accent/30",
  success: "bg-success/10 text-success ring-success/20",
  warning: "bg-warning/10 text-warning ring-warning/25",
  danger: "bg-danger/10 text-danger ring-danger/20",
  info: "bg-info/10 text-info ring-info/20",
};

/** Small status pill. `dot` adds a leading status dot. */
export function Badge({ tone = "neutral", dot = false, className, children, ...props }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded px-2 py-0.5 text-xs font-semibold ring-1 ring-inset",
        TONES[tone],
        className
      )}
      {...props}
    >
      {dot && <span className="h-1.5 w-1.5 rounded-full bg-current" />}
      {children}
    </span>
  );
}

// Maps common KBC domain statuses to a tone, so every screen is consistent.
const STATUS_TONE = {
  approved: "success", active: "success", paid: "success", pro: "primary", yes: "success",
  pending: "warning", review: "warning",
  rejected: "danger", inactive: "danger", unpaid: "neutral", no: "neutral", unpro: "neutral",
  basic: "neutral", advanced: "primary", premium: "accent", admin: "info",
};

export function StatusBadge({ status, className, ...props }) {
  const key = String(status || "").trim().toLowerCase();
  const tone = STATUS_TONE[key] || "neutral";
  const label = status ? String(status).charAt(0).toUpperCase() + String(status).slice(1) : "—";
  return (
    <Badge tone={tone} dot className={className} {...props}>
      {label}
    </Badge>
  );
}

export default Badge;
